import { ticketingAuthHref } from '@/utils/early-bird';
import ThemedIcon from '@/components/ui/ThemedIcon';
import { PathEnum } from '@/i18n/locale-config';
import { useRouter } from '@/i18n/navigation';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';
import AnimatedArrow from '../ui/AnimatedArrow';
import Button from '../ui/Button';
import P from '../ui/P';

export default function RegisterSuccess({
    className,
    returnToCheckout = false,
    giftQuery = '',
}: {
    className?: string;
    returnToCheckout?: boolean;
    giftQuery?: string;
}) {
    const t = useTranslations();
    const router = useRouter();

    return (
        <div
            className={cn(
                'border border-gray3 py-[70px] px-4 flex flex-col gap-7 justify-center items-center border-white',
                className,
            )}
        >
            <ThemedIcon
                aria-label="Success icon"
                className="text-primary"
                src="/img/icons/check.svg"
                width={64}
                height={64}
            />
            <h3 className="uppercase max-lg:text-h4 lg:text-h3 leading-none">
                {t('Form.successTitle')}
            </h3>
            <P
                className={cn(
                    'max-w-[304px] w-full text-center font-helvetica-neue font-light text-white',
                )}
            >
                {t('Form.registeredSuccessfully')}.<br />
                {t('Form.youWillReceiveEmail')}
            </P>
            <Button
                variant="arrow"
                title={t('Form.goToLogin')}
                onClick={() =>
                    router.push(ticketingAuthHref(PathEnum.SignIn, returnToCheckout, giftQuery))
                }
                color={'white'}
                textClasses="text-white"
                className="w-fit"
            >
                <AnimatedArrow className="text-white" width={94} height={86} />
            </Button>
        </div>
    );
}
